import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
import './SavedCuratorFiles.css';

export default function SavedCuratorFiles({ onLoad, onChange, refreshKey = 0 }) {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let cancelled = false;
    apiClient.listCuratorFiles().then((response) => {
      if (!cancelled) { setFiles(response.data.files); setError(''); }
    }).catch((err) => { if (!cancelled) setError(err.message); });
    return () => { cancelled = true; };
  }, [refreshKey, revision]);

  const perform = async (action) => {
    setBusy(true);
    setError('');
    try {
      await action();
      setRevision((value) => value + 1);
      onChange?.();
    } catch (err) { setError(err.message || 'Unable to manage saved files.'); }
    finally { setBusy(false); }
  };

  return <section className="saved-curator-files" aria-label="Saved curator files">
    <h3>Saved curator files</h3>
    <p>Uploads count toward your storage quota. Manage them in Settings.</p>
    {error && <p role="alert">{error}</p>}
    <button type="button" disabled={busy} onClick={() => setRevision((value) => value + 1)}>Refresh files</button>
    {onLoad ? <>
      <select aria-label="Saved curator file" value={selectedId} disabled={busy}
        onChange={(event) => setSelectedId(event.target.value)}>
        <option value="">Select a saved file</option>
        {files.map((file) => <option key={file.id} value={file.id}>{file.name}</option>)}
      </select>
      <button type="button" disabled={busy || !files.some((file) => file.id === selectedId)}
        onClick={() => perform(async () => {
          const response = await apiClient.loadCuratorFile(selectedId);
          onLoad(response.data.dataset, response.data.file.name);
        })}>{busy ? 'Loading…' : 'Load file'}</button>
    </> : <ul>
      {files.map((file) => <li key={file.id}>
        <form onSubmit={(event) => {
          event.preventDefault();
          const name = new FormData(event.currentTarget).get('name');
          perform(() => apiClient.renameCuratorFile(file.id, name));
        }}>
          <input name="name" aria-label={`Filename for ${file.name}`} defaultValue={file.name} maxLength={255} required />
          <span> {file.sizeBytes.toLocaleString()} bytes </span>
          <button type="submit" disabled={busy}>Rename</button>
          <button type="button" disabled={busy} onClick={() => {
            if (window.confirm(`Delete saved file “${file.name}”?`)) {
              perform(() => apiClient.deleteCuratorFile(file.id));
            }
          }}>Delete</button>
        </form>
      </li>)}
    </ul>}
    {!files.length && <p>No saved curator files.</p>}
  </section>;
}
